export const BASE_URL = "https://v2.api.haul247.co/api";

//dev: https://dev.v2.api.haul247.co/api
// prod: https://v2.api.haul247.co/api
